export const FnEditNavbar = {
  IconText: {
    icon: 'fn outline',
    gap: 'X',
    padding: 'X Z1',
    text: '{{ key }}',
    Icon: {
      color: 'dim',
    },
  },
  EditorPositionNavbar: {
    margin: '- - - auto',
  },
  NavbarButtonSet: {
    NavbarButton_docs: {
      isActive: false,
      theme: 'transparent',
      icon: 'question mark',
      color: 'dim',
      onClick: (ev, el) => {
          el.setWindow('docs', '/functions')
        },
    },
    NavbarButton_close: {
      icon: 'crossmark',
      isActive: false,
      onClick: (ev, el) => {
          el.activateFunction(null)
        },
    },
  },
  extends: [
    'MicroNavbar',
    'Navbar',
  ],
  width: '100%',
  padding: 'W1 X X1',
};